/**
 * ./src/modules/product/components/samples/SamplesHeading.tsx
 *
 * SamplesHeading component
 *
 * @copyright DesignShop, 2024
 * @since 06/24/2024
 */
import { cn } from '@/modules/common/lib/utils';

export interface SamplesHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
  level?: 'h1' | 'h2';
  testid?: string;
}
export const SamplesHeading = ({
  id,
  className,
  children,
  testid,
  level = 'h2',
}: SamplesHeadingProps) => {
  return level === 'h1' ?
      <h1
        id={id}
        className={cn('pb-4 pt-8 text-xl font-bold md:py-8 md:text-2xl', className)}
        data-testid={testid || `samples-heading-${level}`}
      >
        {children}
      </h1>
    : <h2
        id={id}
        className={cn('pb-4 pt-8 text-xl font-bold md:py-8 md:text-2xl', className)}
        data-testid={testid || `samples-heading-${level}`}
      >
        {children}
      </h2>;
};
